export default __webpack_public_path__ + "static/article-why-you-should-get-a-low-rate-credit-card-465b3c5406a9a9e0f26e8190901a325e.jpg";